var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPower25(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.9999 7.07067V5.00171H11.1723V7.07067H11.9999Z",
    fill: "#C7CAC7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.249949 8.59096L0.249949 3.40365C0.249949 3.26014 0.366227 3.14386 0.509743 3.14386L10.6626 3.14386C10.8061 3.14386 10.9224 3.26014 10.9224 3.40365L10.9224 8.59096C10.9224 8.73448 10.8061 8.85076 10.6626 8.85076L0.509743 8.85076C0.366227 8.85076 0.249949 8.73448 0.249949 8.59096Z",
    fill: "#E7ECED",
    stroke: "white",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.25 3.40002H0.439538C0.334846 3.40002 0.25 3.59121 0.25 3.82712L0.25 8.17293C0.25 8.40884 0.334846 8.60002 0.439538 8.60002H3.25L3.25 3.40002Z",
    fill: "#6FCF97"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPower25);
export default __webpack_public_path__ + "static/media/power-25.cdc0387e2dc3ca39a7085c123a34128b.svg";
export { ForwardRef as ReactComponent };